import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';
import CustomerCancelOrderAction from './_actions/CustomerCancelOrderAction';
import CustomerApproveActions from './_actions/CustomerApproveActions';

// eslint-disable-next-line react/prefer-stateless-function
class UserOutputCashHistoryTableItem extends Component {
  render() {
    const statusDesc = () => {
      if (this.props.item.status === 2) {
        return (
          <React.Fragment>
            <span className="text-success">
              <i className="fa fa-check-circle" /> {this.props.item.statusDesc}
            </span>
          </React.Fragment>
        );
      } else if (this.props.item.status === 3 || this.props.item.status === 4) {
        return (
          <React.Fragment>
            <span className="text-danger">
              <i className="fa fa-times-circle" /> {this.props.item.statusDesc}
            </span>
          </React.Fragment>
        );
      } else if (this.props.item.status === 5) {
        return (
          <React.Fragment>
            <span className="text-warning">
              <i className="fa fa-times-circle" /> {this.props.item.statusDesc}
            </span>
          </React.Fragment>
        );
      }
      return (
        <React.Fragment>
          <span className="text-info">
            <i className="fa fa-plus-circle" /> {this.props.item.statusDesc}
          </span>
        </React.Fragment>
      );
    };
    return (
      <tr>
        <td className="text-muted">
          {formatter.dateFormat3(this.props.item.createdAt)}
        </td>
        <td>#{this.props.item.serialNumber}</td>
        <td>{statusDesc()}</td>
        <td
          className="td-desc"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: this.props.item.detailDesc }}
        />
        <td className="text-right">
          <div className="text-success">
            {formatter.moneyFormat(this.props.item.sum, 'RUB')}
          </div>
          {this.props.item.totalCurrency !== 'RUB' && (
            <div className="text-muted">
              {formatter.moneyFormat(
                this.props.item.totalSum,
                this.props.item.totalCurrency
              )}
            </div>
          )}
        </td>
        {this.props.awaitConfirmByOwnerExist && (
          <td>
            {this.props.item.status === 6 ? (
              <div style={{ width: '30px' }}>
                <CustomerApproveActions id={this.props.item.id} />{' '}
                <CustomerCancelOrderAction
                  id={this.props.item.id}
                  onRefreshOutputCashHistoryTable={
                    this.props.onRefreshOutputCashHistoryTable
                  }
                />
              </div>
            ) : null}
          </td>
        )}
      </tr>
    );
  }
}

UserOutputCashHistoryTableItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    serialNumber: PropTypes.number.isRequired,
    accountNumber: PropTypes.number.isRequired,
    descOutputAccountsType: PropTypes.string.isRequired,
    statusDesc: PropTypes.string.isRequired,
    detailDesc: PropTypes.string.isRequired,
    sum: PropTypes.string.isRequired,
    totalSum: PropTypes.string.isRequired,
    totalCurrency: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired
  }).isRequired,
  onRefreshOutputCashHistoryTable: PropTypes.func,
  awaitConfirmByOwnerExist: PropTypes.bool.isRequired
};

UserOutputCashHistoryTableItem.defaultProps = {
  onRefreshOutputCashHistoryTable: () => {}
};

export default withRouter(UserOutputCashHistoryTableItem);



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashHistoryTable/UserOutputCashHistoryTableItem.js